import script from "./ScreeningRecommendations.vue?vue&type=script&lang=ts&setup=true"
export * from "./ScreeningRecommendations.vue?vue&type=script&lang=ts&setup=true"

import "./ScreeningRecommendations.vue?vue&type=style&index=0&id=80471154&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80471154"]])

export default __exports__